import React from 'react';
import Table from 'components/Table';
import { numberToCurrencyString, dateToLabel } from 'further-ui/utils';
import { Button } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useLoadMoreAndHideContent } from 'hooks/ui/useLoadMoreContent';
import { Api } from 'further-types/investment';

const useStyles = makeStyles()(() => ({
  summaryRow: {
    backgroundColor: '#FBFBFA',
    marginTop: 4,
  },
  summaryValue: {
    color: '#282525',
    fontSize: 14,
    fontWeight: 'bold',
    marginLeft: 60,
    padding: '10px 24px 10px 0',
  },
  loadMoreContent: {
    paddingTop: '2px',
    width: '90%',
  },
}));

const columns = [
  {
    label: 'Date',
    key: 'date',
    render: (elm) => dateToLabel(elm.date),
  },
  {
    label: 'Interest payment',
    key: 'amount',
    render: (elm) => numberToCurrencyString(elm.amount),
  },
];

type Props = {
  interestPayments?: Api.GetInvestmentDetailsResponse['interest'];
  loading?: boolean;
};

const InterestPayments: React.FC<Props> = ({
  interestPayments = [],
  loading = false,
}) => {
  const { classes } = useStyles();

  const totalInterestPayments = interestPayments.reduce((acc, curr) => {
    const amount = curr.amount;

    return acc + amount;
  }, 0);
  const { onToggle, displayedContent } =
    useLoadMoreAndHideContent(interestPayments);

  return (
    <>
      <Table
        columns={columns}
        tablebody={displayedContent}
        loading={loading}
        emptyMessage="No interest payments found"
        variant="nohover"
        TableFooter={
          <tfoot>
            {interestPayments.length > 10 ? (
              <tr className={classes.summaryRow}>
                <td colSpan={2} align="center">
                  <Button color="primary" onClick={onToggle}>
                    {displayedContent.length > 10
                      ? 'Collapse interest payments table'
                      : ' Click here to show full table contents'}
                  </Button>
                </td>
              </tr>
            ) : null}

            <tr className={classes.summaryRow}>
              <td className={classes.summaryValue} align="right">
                Total interest payments
              </td>
              <td className={classes.summaryValue}>
                {numberToCurrencyString(totalInterestPayments)}
              </td>
            </tr>
          </tfoot>
        }
      />
    </>
  );
};

export default InterestPayments;
